import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "About", href: "#about" },
  { label: "Schedule", href: "#schedule" },
  { label: "Outcomes", href: "#outcomes" },
  { label: "Apply", href: "#apply-buildday" },
];

export const BuildDayNav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="buildday-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-md border-b border-zinc-900"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="/"
          data-testid="buildday-nav-back"
          className="text-white font-extrabold tracking-tight text-base md:text-lg flex items-center gap-2"
        >
          <span className="inline-block w-2 h-2 bg-[#FCD34D]" />
          BUILDERS<span className="text-zinc-500">·</span>SPRINT
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`buildday-nav-link-${item.label.toLowerCase()}`}
              className="text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-white transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#apply-buildday"
          data-testid="buildday-nav-apply-cta"
          className="hidden md:inline-flex items-center text-xs tracking-[0.2em] uppercase font-bold text-black bg-white px-5 py-3 hover:bg-zinc-200 transition-colors duration-300"
        >
          Apply
        </a>

        <button
          data-testid="buildday-nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white"
        >
          <div className="space-y-1.5">
            <span className={`block h-px w-6 bg-white transition-transform duration-300 ${open ? "translate-y-1.5 rotate-45" : ""}`} />
            <span className={`block h-px w-6 bg-white transition-opacity duration-300 ${open ? "opacity-0" : "opacity-100"}`} />
            <span className={`block h-px w-6 bg-white transition-transform duration-300 ${open ? "-translate-y-1.5 -rotate-45" : ""}`} />
          </div>
        </button>
      </div>

      <div className={`md:hidden overflow-hidden border-t border-zinc-900 bg-black transition-[max-height] duration-500 ${open ? "max-h-96" : "max-h-0"}`}>
        <div className="px-6 py-6 flex flex-col gap-5">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              data-testid={`buildday-nav-mobile-link-${item.label.toLowerCase()}`}
              className="text-sm tracking-[0.2em] uppercase text-zinc-300 hover:text-white"
            >
              {item.label}
            </a>
          ))}
          <a
            href="/"
            onClick={() => setOpen(false)}
            data-testid="buildday-nav-mobile-back"
            className="text-xs tracking-[0.2em] uppercase text-zinc-500 hover:text-white"
          >
            ← Builder Programme
          </a>
          <a
            href="#apply-buildday"
            onClick={() => setOpen(false)}
            data-testid="buildday-nav-mobile-apply-cta"
            className="mt-2 inline-flex items-center justify-center text-xs tracking-[0.2em] uppercase font-bold text-black bg-white px-5 py-3"
          >
            Apply For The Sprint
          </a>
        </div>
      </div>
    </header>
  );
};
